import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import EditIcon from '@mui/icons-material/Edit';
import WarningIcon from '@mui/icons-material/Warning';
import SearchIcon from '@mui/icons-material/Search';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
/**
 * Study completeness util class which provides required utils functions.
 */
class StudyCompleteness {

   

    /**
     * Color codes array.
     */
    colorCode: any = {
        sentISF: '#34B450',
        approved: '#42b387',
        readyForApproval: '#6f7bc2',
        //uploaded: '#ffca45',
        uploaded: '#2196F3',
        expected: '#8a4db0',
        rejected: '#ef8033',
        overdue: '#d43332',
        nodata: '#d3d3d3'
    }

    /**
     * Get the color codes study completeness.
     * 
     * @returns Color codes to display in study completeness progress.
     */
    getColorCodes() {
        const colorCodes: any = [];
        for (const [key, value] of Object.entries(this.colorCode)) {
            colorCodes.push(value);
        }
        return colorCodes;
    }

    /**
     * Calculate percentage based on partial value and total value.
     * 
     * @param partialValue Partial value.
     * @param totalValue  Total value.
     * @returns Percentage value.
     */
    percentage(partialValue: any, totalValue = 0) {
        const value = partialValue || 0;
        const total = totalValue || 0;
        return (value / total) * 100;
    }

    /**
     * Returns study completeness data along with percentage.
     * 
     * @param studyCompletenessCount  Study completeness API data.
     * @returns Updated study completeness data with percentage.
     */
    data(studyCompletenessCount: any,tmfLevel:string) {
        const data: any = [
            {
                key: "sentISF",
                name: "Sent To ISF",
                icon: ContentPasteGoIcon,
                color: this.colorCode.sentISF,
                countKey: 'isf_doc_sent_to_isf_count',
                valueActual: studyCompletenessCount?.tmf_doc_sent_to_isf_count || 0,
                value: this.percentage(studyCompletenessCount?.tmf_doc_sent_to_isf_count, studyCompletenessCount?.count_total_transfer_docs),
                totalCount: studyCompletenessCount?.count_total_transfer_docs || 0,
                enabled: true
            },
            {
                key: "approved",
                name: "Approved",
                icon: CheckCircleIcon,
                color: this.colorCode.approved,
                countKey: 'tmf_doc_approved_count',
                valueActual: studyCompletenessCount?.tmf_doc_approved_count || 0,
                value: this.percentage(studyCompletenessCount?.tmf_doc_approved_count, studyCompletenessCount?.tmf_doc_total_count),
                totalCount: studyCompletenessCount?.tmf_doc_total_count || 0,
                enabled: true
            },
            {
                key: "readyForApproval",
                name: "Ready for Approval",
                icon: SearchIcon,
                color: this.colorCode.readyForApproval,
                countKey: 'tmf_doc_Ready_for_approval_count',
                valueActual: studyCompletenessCount?.tmf_doc_Ready_for_approval_count || 0,
                value: this.percentage(studyCompletenessCount?.tmf_doc_Ready_for_approval_count, studyCompletenessCount?.tmf_doc_total_count),
                totalCount: studyCompletenessCount?.tmf_doc_total_count || 0,
                enabled: true
            },
            {
                key: "uploaded",
                name: "Uploaded",
                icon: EditIcon,
                color: this.colorCode.uploaded,
                countKey: 'tmf_doc_uploaded_count',
                valueActual: studyCompletenessCount?.tmf_doc_uploaded_count || 0,
                value: this.percentage(studyCompletenessCount?.tmf_doc_uploaded_count, studyCompletenessCount?.tmf_doc_total_count),
                totalCount: studyCompletenessCount?.tmf_doc_total_count || 0,
                enabled: true
            },
            {
                key: "expected",
                name: "Expected",
                icon: PendingActionsIcon,
                color: this.colorCode.expected,
                countKey: 'tmf_doc_expected_count',
                valueActual: studyCompletenessCount?.tmf_doc_expected_count || 0,
                value: this.percentage(studyCompletenessCount?.tmf_doc_expected_count, studyCompletenessCount?.tmf_doc_total_count),
                totalCount: studyCompletenessCount?.tmf_doc_total_count || 0,
                enabled: true
            },
            {
                key: "rejected",
                name: "Rejected",
                icon: DoNotDisturbIcon,
                color: this.colorCode.rejected,
                countKey: 'tmf_doc_uploaded_count',
                valueActual: studyCompletenessCount?.tmf_doc_rejected_count || 0,
                value: this.percentage(studyCompletenessCount?.tmf_doc_rejected_count, studyCompletenessCount?.tmf_doc_total_count),
                totalCount: studyCompletenessCount?.tmf_doc_total_count || 0,
                enabled: true
            },
            {
                key: "overdue",
                name: "Overdue",
                icon: WarningIcon,
                color: this.colorCode.overdue,
                countKey: 'tmf_doc_inprogress_count',
                valueActual: studyCompletenessCount?.tmf_doc_overdue_count || 0,
                value: this.percentage(studyCompletenessCount?.tmf_doc_overdue_count, studyCompletenessCount?.tmf_doc_total_count),
                totalCount: studyCompletenessCount?.tmf_doc_total_count || 0,
                enabled: false
            }
        ];
        if(tmfLevel !== 'Site') data.shift()
        return data;
    }
}

export default StudyCompleteness;